(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complexion-quiz-logic"]) return;
  try {
    
  (function () {
    var cqLoaderFinishedForResults = false;
    var cqHeroInjectPendingReveal = false;
    var cqComplexionResultsUiRevealed = false;

    /* ── Videowise reveal gate ──
     * The hero is injected (and Videowise triggered) while the quiz loader is
     * still up, but the widget renders async — without a gate the videos pop
     * in after the results screen is already visible. The injected hero is
     * laid out under the fullscreen qf-quiz overlay (not display:none), so a
     * rendered widget has a real box height we can poll for pre-reveal.
     * Bounded: settles after CQ_VW_REVEAL_CAP_MS no matter what, and heroes
     * without a Videowise embed never block. */
    var cqVideowiseReadyForReveal = true;
    var cqVideowiseRevealPollTimer = null;
    var cqVideowiseRevealCapTimer = null;
    var CQ_VW_REVEAL_CAP_MS = 2500;

    function cqClearVideowiseRevealGate() {
      if (cqVideowiseRevealPollTimer) {
        window.clearInterval(cqVideowiseRevealPollTimer);
        cqVideowiseRevealPollTimer = null;
      }
      if (cqVideowiseRevealCapTimer) {
        window.clearTimeout(cqVideowiseRevealCapTimer);
        cqVideowiseRevealCapTimer = null;
      }
    }

    function cqSettleVideowiseRevealGate() {
      cqClearVideowiseRevealGate();
      if (cqVideowiseReadyForReveal) return;
      cqVideowiseReadyForReveal = true;
      tryRevealComplexionQuizResultsUiAfterLoader();
    }

    /* Scoped to the Videowise containers of both hero generations so gallery
     * videos/iframes elsewhere in the hero can't count as "rendered".
     * IMPORTANT: the raw embed markup (copied verbatim from section settings by
     * cqForceInjectDeferredVideowise, or inline in the old hero) can itself have
     * children / non-empty HTML / height before Videowise renders anything, so a
     * static "does it have content" check would settle the gate on placeholder
     * markup. Instead we snapshot the containers as a BASELINE on the first poll
     * tick (after the force-inject has run) and treat the widget as rendered
     * only when app-generated nodes appear or the widget grows past that
     * baseline (the closed-shadow widget shows growth as box height). */
    function cqVideowiseRevealMetrics(heroEl) {
      var m = { cards: 0, media: 0, children: 0, html: 0, height: 0 };
      if (!heroEl) return m;
      var scopes = heroEl.querySelectorAll('.phn-ugc, .product__description-videowise, .ph-videowise');
      for (var i = 0; i < scopes.length; i++) {
        var scope = scopes[i];
        m.cards += scope.querySelectorAll('[data-videowise-id], .vw-cmp__video-card, .vw-cmp__item').length;
        m.media += scope.querySelectorAll('iframe, video').length;
        var widgets = scope.querySelectorAll('.reeview-app-widget');
        for (var j = 0; j < widgets.length; j++) {
          var el = widgets[j];
          m.children += el.children ? el.children.length : 0;
          m.html += String(el.innerHTML || '').length;
          var rect = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
          m.height += rect ? rect.height : 0;
        }
      }
      return m;
    }

    function cqVideowiseGrewPastBaseline(now, base) {
      return (
        now.media > base.media ||
        now.children > base.children ||
        now.html > base.html ||
        now.height > base.height + 1
      );
    }

    function cqArmVideowiseRevealGate(heroEl) {
      cqClearVideowiseRevealGate();
      cqVideowiseReadyForReveal = true;
      if (!heroEl || typeof heroEl.querySelector !== 'function') return;
      /* [data-phn-videowise-html] covers the phn hero before its deferred
       * template is force-injected (that happens in syncVideowiseForQuizProduct,
       * which runs a few lines after this gate is armed). */
      var hasEmbed = heroEl.querySelector(
        '.reeview-app-widget, .product__description-videowise, .ph-videowise, [data-phn-videowise-html]'
      );
      if (!hasEmbed) return;
      cqVideowiseReadyForReveal = false;
      var baseline = null;
      cqVideowiseRevealPollTimer = window.setInterval(function () {
        if (!heroEl.isConnected) {
          cqSettleVideowiseRevealGate();
          return;
        }
        var now = cqVideowiseRevealMetrics(heroEl);
        /* Videowise-generated card nodes are never part of pasted embed code —
         * their presence alone means the app rendered, baseline or not. */
        if (now.cards > 0) {
          cqSettleVideowiseRevealGate();
          return;
        }
        if (!baseline) {
          /* First tick (~150ms in): the force-injected placeholder markup is in
           * place but the app almost certainly hasn't rendered yet — this is
           * the "empty widget" reference all later ticks compare against. */
          baseline = now;
          return;
        }
        if (cqVideowiseGrewPastBaseline(now, baseline)) {
          cqSettleVideowiseRevealGate();
        }
      }, 150);
      cqVideowiseRevealCapTimer = window.setTimeout(cqSettleVideowiseRevealGate, CQ_VW_REVEAL_CAP_MS);
    }
    var cqFaqsSyncSeq = 0;
    var cqResultsRunId = 0;
    var cqRevealSafetyTimerFast = null;
    var cqRevealSafetyTimerSlow = null;

    function cqDelay(ms) {
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    }

    /** Retries transient network / 5xx failures so one bad hop does not strand the loader. */
    function cqFetchWithRetries(url, init, opts) {
      opts = opts || {};
      var max = opts.maxAttempts != null ? opts.maxAttempts : 3;
      var base = opts.baseBackoffMs != null ? opts.baseBackoffMs : 450;
      function attempt(i) {
        return fetch(url, init || {}).then(
          function (res) {
            if (res.ok) return res;
            var st = res.status;
            var retryable = st === 502 || st === 503 || st === 504 || st === 429;
            if (retryable && i + 1 < max) {
              return cqDelay(base * (i + 1)).then(function () {
                return attempt(i + 1);
              });
            }
            return res;
          },
          function () {
            if (i + 1 < max) {
              return cqDelay(base * (i + 1)).then(function () {
                return attempt(i + 1);
              });
            }
            return Promise.reject(new Error('cqFetchWithRetries failed after ' + max + ' attempts'));
          }
        );
      }
      return attempt(0);
    }

    function cqClearRevealSafetyTimers() {
      clearTimeout(cqRevealSafetyTimerFast);
      clearTimeout(cqRevealSafetyTimerSlow);
      cqRevealSafetyTimerFast = null;
      cqRevealSafetyTimerSlow = null;
    }

    /** Legacy PDP hero + `product-hero-new` / `sections/product.liquid` markers for Section Rendering scans. */
    function cqHeroAnchorRe() {
      return (
        /class="[^"]*\bproduct__hero\b[^"]*"|class="[^"]*\bjs-productSection\b[^"]*"|data-view="product"|data-phn-root(?:="[^"]*")?|class="[^"]*\bphn-product\b[^"]*"|<product-hero-new\b|data-ph-product-section(?:="[^"]*")?|data-phn-section(?:="[^"]*")?/
      );
    }

    function cqHeroMarkupLooksValid(inner) {
      if (!inner) return false;
      return (
        inner.indexOf('product__hero') !== -1 ||
        inner.indexOf('js-productSection') !== -1 ||
        inner.indexOf('data-phn-root') !== -1 ||
        inner.indexOf('product-hero-new') !== -1 ||
        inner.indexOf('phn-product') !== -1 ||
        inner.indexOf('data-ph-product-section') !== -1 ||
        inner.indexOf('data-phn-section') !== -1
      );
    }

    function cqFindHeroDescriptionMount(heroRoot) {
      if (!heroRoot) return null;
      return (
        heroRoot.querySelector('.product__description-main') ||
        heroRoot.querySelector('.phn-info') ||
        heroRoot.querySelector('.product__info-wrapper') ||
        heroRoot.querySelector('[data-phn-root]') ||
        heroRoot.querySelector('[data-ph-product-section]') ||
        heroRoot
      );
    }

    function cqParseSwatchColorsSetting(raw) {
      var map = Object.create(null);
      if (raw == null || raw === '') return map;
      if (typeof raw !== 'string') {
        try {
          raw = String(raw);
        } catch (e) {
          return map;
        }
      }
      raw.split(/\r?\n/).forEach(function (line) {
        line = String(line || '').trim();
        if (!line) return;
        var sep = line.indexOf('==') !== -1 ? '==' : '=';
        var idx = line.indexOf(sep);
        if (idx <= 0) return;
        var name = line.slice(0, idx).trim().toLowerCase();
        var color = line.slice(idx + sep.length).trim();
        if (name && color) map[name] = color;
      });
      return map;
    }

    var cqThemeSwatchColorsMap = (function () {
      try {
        var el = document.getElementById('cq-theme-swatch-colors');
        if (!el || !el.textContent) return cqParseSwatchColorsSetting('');
        var parsed = JSON.parse(el.textContent);
        return cqParseSwatchColorsSetting(typeof parsed === 'string' ? parsed : '');
      } catch (e) {
        return Object.create(null);
      }
    })();

    function cqLookupThemeSwatchColor(shadeName) {
      var key = String(shadeName || '').trim().toLowerCase();
      if (!key) return '';
      return cqThemeSwatchColorsMap[key] || '';
    }

    function cqNormalizeHexColor(value) {
      var color = String(value || '').trim();
      if (!color) return '';
      if (/^#/.test(color)) return color;
      if (/^[0-9a-f]{3,8}$/i.test(color)) return '#' + color;
      return color;
    }

    function cqSwatchStyleFromHeroDom(heroRoot, shadeName, variantId) {
      if (!heroRoot) return '';
      var btn = null;
      if (variantId != null && variantId !== '') {
        btn = heroRoot.querySelector('[data-phn-std-shade][data-variant-id="' + variantId + '"]');
      }
      var want = String(shadeName || '').trim().toLowerCase();
      if (!btn && want) {
        heroRoot.querySelectorAll('[data-phn-std-shade]').forEach(function (b) {
          var title = (b.getAttribute('data-variant-title') || '').trim().toLowerCase();
          if (title === want) btn = b;
        });
      }
      if (!btn) return '';
      var inner = btn.querySelector('.phn-form-std__swatch-inner');
      if (!inner) return '';
      var style = inner.getAttribute('style') || '';
      if (!style) return '';

      var imgMatch = style.match(/background-image\s*:\s*url\(\s*['"]?([^'")]+)/i);
      if (imgMatch && imgMatch[1]) {
        return 'background-image:url(' + imgMatch[1] + ');background-size:cover;background-position:center';
      }
      var colorMatch = style.match(/background-color\s*:\s*([^;]+)/i);
      if (colorMatch && colorMatch[1]) {
        return 'background-color:' + colorMatch[1].trim();
      }
      var bgMatch = style.match(/background\s*:\s*([^;]+)/i);
      if (bgMatch && bgMatch[1] && !/url\(/i.test(bgMatch[1])) {
        return 'background-color:' + bgMatch[1].trim();
      }
      return '';
    }

    /**
     * IG media gallery test (Intelligems — see product-hero-new.liquid): on test
     * PDPs the section cloaks thumbnails 2+ (`phn-ig-thumb-cloak` + inline style)
     * and an inline script resolves the test group, swaps treatment media in, and
     * uncloaks. Scripts injected via innerHTML never execute, so on quiz results
     * that cloak would stay forever and only the first thumbnail would show.
     * Mirror the inline script here: for the treatment group flag the upgraded
     * hero element (`_igActive`, so later shade changes keep IG media) and rebuild
     * the gallery from the IG media map; uncloak either way.
     */
    function cqResolveIgGalleryForInjectedHero(mount, variantId) {
      if (!mount) return;

      function uncloak() {
        mount.querySelectorAll('.phn-ig-thumb-cloak').forEach(function (el) {
          el.classList.remove('phn-ig-thumb-cloak');
        });
      }

      var igEl = mount.querySelector('[data-phn-std-variant-media-ig]');
      if (!igEl) {
        uncloak();
        return;
      }

      var testId = igEl.getAttribute('data-ig-test-id');
      var treatmentId = igEl.getAttribute('data-ig-treatment-id');
      var done = false;

      function applyTreatmentSwap() {
        var hero = mount.querySelector('product-hero-new');
        if (!hero) return;
        hero._igActive = true;
        if (typeof hero._swapGalleryToVariant !== 'function') {
          /* Element not upgraded yet (section-product-hero-new.js still loading). */
          if (window.customElements && customElements.whenDefined) {
            customElements.whenDefined('product-hero-new').then(function () {
              if (document.contains(hero)) {
                hero._igActive = true;
                applyTreatmentSwap();
              }
            });
          }
          return;
        }
        var wrapper = hero.querySelector('.js-productMedia .swiper-wrapper');
        var vid =
          variantId != null && variantId !== ''
            ? String(variantId)
            : (wrapper && wrapper.dataset.phnActiveVariant) || '';
        if (!vid) return;
        var igMedia = null;
        try {
          igMedia = (JSON.parse(igEl.textContent) || {})[vid];
        } catch (e) {}
        /* No IG media for this variant — control media is the correct fallback (same as PDP). */
        if (!igMedia || !igMedia.length) return;
        /* SSR markup holds control media under this same variant id; clear the
           flag so _swapGalleryToVariant doesn't skip the rebuild as a no-op. */
        if (wrapper) delete wrapper.dataset.phnActiveVariant;
        try {
          hero._swapGalleryToVariant(vid);
        } catch (e2) {}
      }

      function run() {
        if (done) return;
        /* Mount re-injected since this resolver was armed — stale ig:ready callback. */
        if (!document.contains(igEl)) {
          done = true;
          return;
        }
        var g =
          window.igData &&
          window.igData.user &&
          typeof window.igData.user.getTestGroup === 'function' &&
          window.igData.user.getTestGroup(testId);
        if (!g) return;
        done = true;
        if (treatmentId && g.id === treatmentId) applyTreatmentSwap();
        uncloak();
      }

      run();
      if (!done) {
        window.addEventListener('ig:ready', run, { once: true });
        /* Safety net (the PDP uses `window load`, long past here): never leave thumbs 2+ hidden. */
        setTimeout(function () {
          if (!done) {
            uncloak();
          }
        }, 3000);
      }
    }

    function bindComplexionQuizHeaderBackOnce() {
      var back = document.querySelector('.quiz-header .js-quiz-header-back-cq');
      if (!back || back.dataset.cqQuizBackBound === '1') return;
      back.dataset.cqQuizBackBound = '1';
      back.addEventListener('click', function () {
        var style = document.getElementById('quiz-logic-style');
        if (style) style.remove();
        document.body.classList.remove('quiz-recommendations-ready');

        if (!document.body.classList.contains('cq-complexion-results-active')) {
          return;
        }

        document.body.classList.remove('cq-complexion-results-active');
        var q = document.querySelector('qf-quiz');
        if (q && q.goToStepById) {
          q.goToStepById('pre_results');
          q.style.display = '';
        }
        document.dispatchEvent(new CustomEvent('quiz:results-reset'));
      });
    }

    function runWhenDomReady(fn) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn);
      } else {
        fn();
      }
    }

    runWhenDomReady(bindComplexionQuizHeaderBackOnce);

    function finalizeComplexionQuizResultsShell() {
      var quiz = document.querySelector('qf-quiz');

      if (quiz) {
        quiz.style.display = 'none';
      }
      document.documentElement.classList.remove('quiz-flow-overflow-hidden');
      document.body.classList.add('cq-complexion-results-active');
      bindComplexionQuizHeaderBackOnce();
    }

    function tryRevealComplexionQuizResultsUiAfterLoader() {
      if (cqComplexionResultsUiRevealed) return;
      if (!cqHeroInjectPendingReveal || !cqLoaderFinishedForResults) return;
      /* Hold the reveal (bounded, see cqArmVideowiseRevealGate) until the
       * Videowise widget has rendered under the loader — the gate calls back
       * into this function when it settles. */
      if (!cqVideowiseReadyForReveal) return;
      cqHeroInjectPendingReveal = false;
      cqComplexionResultsUiRevealed = true;
      cqClearVideowiseRevealGate();
      finalizeComplexionQuizResultsShell();
    }

    /**
     * Quiz app must dispatch `complexion-quiz:loader-finished` on `document` when the loader step
     * finishes (no `detail`). PDP shell hides `qf-quiz` only after both hero inject and this event.
     * Saved-result URLs (`?result=` / `?uid=`): inline script dispatches `complexion-quiz:results-ready`
     * as soon as `/result` returns (prep builds hero in background); this event still gates final reveal.
     */
    document.addEventListener('complexion-quiz:loader-finished', function () {
      cqLoaderFinishedForResults = true;
      tryRevealComplexionQuizResultsUiAfterLoader();
      if (typeof queueMicrotask === 'function') {
        queueMicrotask(function () {
          tryRevealComplexionQuizResultsUiAfterLoader();
        });
      } else {
        setTimeout(function () {
          tryRevealComplexionQuizResultsUiAfterLoader();
        }, 0);
      }
    }, true);

    document.addEventListener('quiz:results-reset', function () {
      cqClearRevealSafetyTimers();
      cqFaqsSyncSeq++;
      document.body.classList.remove('cq-complexion-results-active');
      var quizReset = document.querySelector('qf-quiz');
      if (quizReset) quizReset.style.display = '';
      cqLoaderFinishedForResults = false;
      cqHeroInjectPendingReveal = false;
      cqComplexionResultsUiRevealed = false;
      cqClearVideowiseRevealGate();
      cqVideowiseReadyForReveal = true;
    });

    function onComplexionQuizResultsReady(event) {
      var loaderFinishedBeforeThisHandler = cqLoaderFinishedForResults;
      cqResultsRunId++;
      var cqThisResultsRunId = cqResultsRunId;
      cqClearRevealSafetyTimers();
      cqHeroInjectPendingReveal = false;
      cqComplexionResultsUiRevealed = false;
      cqLoaderFinishedForResults = false;
      cqClearVideowiseRevealGate();
      cqVideowiseReadyForReveal = true;

      const data = event.detail;
      const products = data?.recommendedProducts || [];
      const recommendedShadesByProduct = Array.isArray(data?.recommendedShadesByProduct)
        ? data.recommendedShadesByProduct
        : [];
      const bestEntry = products[0];
      const handle = bestEntry?.handle;
      const productHeroTarget = document.querySelector('[data-product-hero-target]');
      const headingTitle = document.querySelector('[data-cq-quiz-heading-title]');

      if (!handle || !productHeroTarget) {
        return;
      }

      if (loaderFinishedBeforeThisHandler) {
        cqLoaderFinishedForResults = true;
      }

      /* First paint has `data-cq-dynamic-faqs` from Liquid; after FAQ sync innerHTML is PDP markup without it — fall back to section class so re-entry after pre_results still resolves the mount. */
      var cqFaqsShopifySectionEl = (function () {
        var root =
          document.querySelector('body[data-template="complexion-quiz"]') || document.body;
        var m = root.querySelector('[data-cq-dynamic-faqs="1"]');
        if (m) return m.closest('.shopify-section');
        return root.querySelector('.shopify-section.product-faqs-section');
      })();

      if (headingTitle) {
        const firstName = String(data?.firstName || '').trim();
        headingTitle.textContent = firstName
          ? firstName + ', here are your personalized results'
          : 'Here are your personalized results';
      }

      function normalizeProductHandle(h) {
        return String(h || '').trim().toLowerCase();
      }

      function normalizeShade(value) {
        return String(value || '').trim().toLowerCase();
      }

      /** Stable comparison of all quiz shade fields we might show on pick vs best hero. */
      function complexionQuizEntryShadeFingerprint(entry) {
        if (!entry) return '';
        return [
          normalizeShade(entry.faceShade),
          normalizeShade(entry.underEyeShade),
          normalizeShade(entry.neutralizerShade),
          normalizeShade(entry.allOverShade),
          normalizeShade(entry.colorCorrectShade),
          normalizeShade(entry.bluePurpleRedShade),
          normalizeShade(entry.greenGreyBrownShade),
        ].join('\u0001');
      }

      /** First non-empty shade on a recommended row — variant title match + “Your match” line (not face-only). */
      function complexionQuizPrimaryShadeName(entry) {
        if (!entry) return '';
        var keys = [
          'faceShade',
          'allOverShade',
          'underEyeShade',
          'neutralizerShade',
          'colorCorrectShade',
          'bluePurpleRedShade',
          'greenGreyBrownShade',
        ];
        for (var i = 0; i < keys.length; i++) {
          var v = entry[keys[i]];
          if (v != null && String(v).trim() !== '') return String(v).trim();
        }
        return '';
      }

      let urlProductParam = '';
      try {
        urlProductParam = normalizeProductHandle(new URL(window.location.href).searchParams.get('product'));
      } catch (e) {}

      function findRecommendedShadesByProductRow(productHandle) {
        if (!productHandle) return null;
        const target = normalizeProductHandle(productHandle);
        return (
          recommendedShadesByProduct.find(function (item) {
            if (!item) return false;
            var h = normalizeProductHandle(
              item.productHandle || item.handle || item.product || item.product_handle || '',
            );
            return h === target;
          }) || null
        );
      }

      /**
       * Maps recommendedShadesByProduct shade object (quiz API keys) onto recommendedProducts row keys.
       * Supports face / allOver / underEye / color correct / neutralizer columns, etc.
       */
      function shadeMapObjectToEntryFields(shadeObj) {
        if (!shadeObj || typeof shadeObj !== 'object') return {};
        function get(o) {
          for (var i = 1; i < arguments.length; i++) {
            var k = arguments[i];
            if (!Object.prototype.hasOwnProperty.call(o, k)) continue;
            var v = o[k];
            if (v != null && String(v).trim() !== '') return String(v).trim();
          }
          return '';
        }
        var o = shadeObj;
        var out = {};
        var f = get(o, 'face', 'faceShade');
        if (f) out.faceShade = f;
        var ao = get(o, 'allOver', 'all_over', 'allOverShade');
        if (ao) out.allOverShade = ao;
        var ue = get(o, 'underEye', 'under_eye', 'underEyeShade');
        if (ue) out.underEyeShade = ue;
        var nz = get(o, 'neutralizer', 'neutralizerShade');
        if (nz) out.neutralizerShade = nz;
        var cc = get(o, 'colorCorrect', 'color_correct', 'colorCorrectShade');
        if (cc) out.colorCorrectShade = cc;
        var bpr = get(o, 'bluePurpleRed', 'blue_purple_red', 'bluePurpleRedShade');
        if (bpr) out.bluePurpleRedShade = bpr;
        var ggb = get(o, 'greenGreyBrown', 'green_grey_brown', 'greenGreyBrownShade');
        if (ggb) out.greenGreyBrownShade = ggb;
        return out;
      }

      function getShadeMapFieldsForHandle(productHandle) {
        var row = findRecommendedShadesByProductRow(productHandle);
        if (!row) return {};
        var shadeObj = row.recomededShade || row.recommendedShade || {};
        return shadeMapObjectToEntryFields(shadeObj);
      }

      function complexionQuizEntryWithMergedShades(entry) {
        if (!entry || !entry.handle) return entry;
        return Object.assign({}, getShadeMapFieldsForHandle(entry.handle), entry);
      }

      /** URL "your pick" only uses tabbed UI when the quiz returned a non-empty shade map row for that handle. */
      function shadeMapRowHasAnyRecommendedShade(row) {
        if (!row) return false;
        var o = row.recomededShade || row.recommendedShade;
        if (!o || typeof o !== 'object') return false;
        for (var k in o) {
          if (!Object.prototype.hasOwnProperty.call(o, k)) continue;
          var v = o[k];
          if (v != null && String(v).trim() !== '') return true;
        }
        return false;
      }

      function urlPickHasRecommendedShadesInMap() {
        if (!urlProductParam) return true;
        var row = findRecommendedShadesByProductRow(urlProductParam);
        return shadeMapRowHasAnyRecommendedShade(row);
      }

      function findRecommendedProductByHandle(productHandle) {
        var target = normalizeProductHandle(productHandle);
        if (!target) return null;
        return (
          products.find(function (p) {
            return p && normalizeProductHandle(p.handle) === target;
          }) || null
        );
      }

      function resolveNeutralizerUrlSubstitutePick() {
        if (!urlProductParam || urlPickHasRecommendedShadesInMap()) return null;
        if (urlProductParam === 'the-neutralizer-pencil') {
          var fp = findRecommendedProductByHandle('the-face-pencil');
          var nz = fp && String(fp.neutralizerShade || '').trim();
          if (!nz) return null;
          return Object.assign({}, fp, {
            handle: 'the-face-pencil',
            faceShade: '',
            underEyeShade: '',
            neutralizerShade: nz,
          });
        }
        if (urlProductParam === 'wide-awake-brightening-neutralizer') {
          var concealer = findRecommendedProductByHandle('wide-awake-brightening-concealer');
          var ue = concealer && String(concealer.underEyeShade || '').trim();
          if (ue) {
            return Object.assign({}, concealer, {
              handle: 'wide-awake-brightening-concealer',
              faceShade: '',
              underEyeShade: ue,
            });
          }
          var waFp = findRecommendedProductByHandle('the-face-pencil');
          var waNz = waFp && String(waFp.neutralizerShade || '').trim();
          if (!waNz) return null;
          return Object.assign({}, waFp, {
            handle: 'the-face-pencil',
            faceShade: '',
            underEyeShade: '',
            neutralizerShade: waNz,
          });
        }
        return null;
      }

      const pickFromRecommendedProducts = urlProductParam
        ? products.find(function (p) {
            return p && normalizeProductHandle(p.handle) === urlProductParam;
          })
        : null;
      const shadeOverrides = urlProductParam ? getShadeMapFieldsForHandle(urlProductParam) : {};
      const substitutePick = resolveNeutralizerUrlSubstitutePick();
      const pickEntry = substitutePick
        ? substitutePick
        : urlProductParam
          ? Object.assign({}, pickFromRecommendedProducts || {}, shadeOverrides, {
              handle: urlProductParam,
            })
          : null;

      const pickUnderEyeStr = String((pickEntry && pickEntry.underEyeShade) || '').trim();

      const pickMatchesBest =
        !!(
          pickEntry &&
          bestEntry &&
          normalizeProductHandle(pickEntry.handle) === normalizeProductHandle(bestEntry.handle) &&
          complexionQuizEntryShadeFingerprint(pickEntry) === complexionQuizEntryShadeFingerprint(bestEntry)
        );

      let dualTabs = !!(
        pickEntry &&
        pickEntry.handle &&
        !pickMatchesBest &&
        (urlPickHasRecommendedShadesInMap() || !!substitutePick)
      );

      /* Face Pencil + ?product=the-face-pencil: tabbed hero needs faceShade on pick. If quiz only
         recommends underEyeShade (no face), skip tabs — hero stays best match only; Face Pencil tile
         remains in essentials with under-eye shade only. */
      if (
        urlProductParam &&
        normalizeProductHandle(urlProductParam) === 'the-face-pencil' &&
        pickEntry &&
        !String(pickEntry.faceShade || '').trim() &&
        pickUnderEyeStr
      ) {
        dualTabs = false;
      }

      const tabState = {
        dualTabs: dualTabs,
        activeTab: dualTabs ? 'pick' : 'best',
        pickEntry: pickEntry,
        bestEntry: bestEntry,
      };

      let heroLoadSeq = 0;
      let dualHeroBundles = null;

      function switchComplexionQuizHeroTab(which) {
        if (!tabState.dualTabs) return;
        if (which !== 'pick' && which !== 'best') return;
        if (which === tabState.activeTab) return;
        const nextEntry = which === 'pick' ? tabState.pickEntry : tabState.bestEntry;
        if (!nextEntry || !nextEntry.handle) return;
        tabState.activeTab = which;

        if (dualHeroBundles && dualHeroBundles[which]) {
          const b = dualHeroBundles[which];
          injectHero(b.html, b.variantData, b.productId, {
            quizData: data,
            recommendedEntry: nextEntry,
            dualTabs: true,
            activeTab: which,
            videowiseMode: 'full',
            variantId: b.variantId,
          });
          return;
        }

        fetchPDPHeroForEntry(nextEntry, { videowiseMode: 'full', uiActiveTab: which });
      }

      function bindComplexionQuizHeroTabsIfNeeded(heroMountEl) {
        const dm = cqFindHeroDescriptionMount(heroMountEl);
        if (!dm || !tabState.dualTabs || dm.dataset.cqDualTabBound === '1') return;
        dm.dataset.cqDualTabBound = '1';
        dm.addEventListener('click', function (ev) {
          const btn = ev.target.closest('[data-cq-tab]');
          if (!btn || !dm.contains(btn)) return;
          const t = btn.getAttribute('data-cq-tab');
          if (t !== 'pick' && t !== 'best') return;
          ev.preventDefault();
          switchComplexionQuizHeroTab(t);
        });
      }

      function unwrapShopifySectionHtml(html) {
        var fragment = html.trim();
        for (var i = 0; i < 3; i++) {
          var tpl = document.createElement('template');
          tpl.innerHTML = fragment;
          var root = tpl.content.firstElementChild;
          if (root && root.id && /^shopify-section-/i.test(root.id)) {
            fragment = root.innerHTML.trim();
          } else {
            break;
          }
        }
        return fragment;
      }

      function heroSectionIdCacheKey(productHandle) {
        return 'jrb_cq_pdp_hero_section_v2:' + productHandle;
      }

      // Last id="shopify-section-template--…" before the product hero root (section wraps hero in DOM order).
      function extractProductHeroSectionIdFromHtmlChunk(buffer) {
        if (!buffer || buffer.indexOf('shopify-section') === -1) return null;
        var heroRe = cqHeroAnchorRe();
        var hm = heroRe.exec(buffer);
        if (!hm) return null;
        var head = buffer.slice(0, hm.index);
        var secRe = /id="shopify-section-(template--[^"]+)"/g;
        var last = null;
        var sm;
        while ((sm = secRe.exec(head)) !== null) {
          last = sm[1];
        }
        return last;
      }

      function resolveProductHeroSectionId(productHandle) {
        var cacheKey = heroSectionIdCacheKey(productHandle);
        try {
          var cached = sessionStorage.getItem(cacheKey);
          if (cached && /^template--/.test(cached)) return Promise.resolve(cached);
        } catch (e) {}

        var url = '/products/' + encodeURIComponent(productHandle);
        var MAX_BYTES = 2800000;

        return cqFetchWithRetries(
          url,
          {
            method: 'GET',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html,*/*' },
          },
          { maxAttempts: 3, baseBackoffMs: 400 }
        ).then(function (response) {
          if (!response.ok) {
            throw new Error('PDP fetch failed while resolving section id: ' + response.status);
          }
          var reader = response.body && response.body.getReader();
          if (!reader) {
            return response.text().then(function (html) {
              var id = extractProductHeroSectionIdFromHtmlChunk(html);
              if (!id) throw new Error('Unable to find product hero shopify-section wrapper');
              try {
                sessionStorage.setItem(cacheKey, id);
              } catch (e2) {}
              return id;
            });
          }

          var decoder = new TextDecoder();
          var buffer = '';

          function pump() {
            return reader.read().then(function (result) {
              if (result.done) {
                var idDone = extractProductHeroSectionIdFromHtmlChunk(buffer);
                if (!idDone) throw new Error('Unable to find product hero shopify-section wrapper');
                try {
                  sessionStorage.setItem(cacheKey, idDone);
                } catch (e3) {}
                return idDone;
              }

              buffer += decoder.decode(result.value, { stream: true });

              var id = extractProductHeroSectionIdFromHtmlChunk(buffer);
              if (id) {
                try {
                  sessionStorage.setItem(cacheKey, id);
                } catch (e4) {}
                reader.cancel().catch(function () {});
                return id;
              }

              if (buffer.length >= MAX_BYTES) {
                var idCap = extractProductHeroSectionIdFromHtmlChunk(buffer);
                if (!idCap) throw new Error('Product hero section id not found within PDP scan limit');
                try {
                  sessionStorage.setItem(cacheKey, idCap);
                } catch (e5) {}
                reader.cancel().catch(function () {});
                return idCap;
              }

              return pump();
            });
          }

          return pump();
        });
      }

      function fetchHeroSectionMarkup(productHandle, variantId, sectionId) {
        var params = new URLSearchParams({ section_id: sectionId });
        if (variantId != null && variantId !== '') params.set('variant', String(variantId));
        var url = '/products/' + encodeURIComponent(productHandle) + '?' + params.toString();

        return cqFetchWithRetries(
          url,
          { method: 'GET', headers: { 'X-Requested-With': 'XMLHttpRequest' } },
          { maxAttempts: 3, baseBackoffMs: 400 }
        )
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Section render request failed: ' + response.status);
            }
            return response.text();
          })
          .then(function (raw) {
            var inner = unwrapShopifySectionHtml(raw);
            if (!cqHeroMarkupLooksValid(inner)) {
              throw new Error('Resolved section id did not return product hero markup');
            }
            return inner;
          });
      }

      function fetchProductHeroMarkup(productHandle, variantId) {
        return resolveProductHeroSectionId(productHandle).then(function (sectionId) {
          return fetchHeroSectionMarkup(productHandle, variantId, sectionId);
        });
      }

      function faqsSectionIdCacheKey(productHandle) {
        return 'jrb_cq_pdp_faqs_section:' + productHandle;
      }

      /**
       * Last `shopify-section` id before the FAQ section on the recommended
       * product's PDP. Accepts both classes:
       *   - `product-faqs-section` — Main's PDP (`sections/product-faqs.liquid`)
       *   - `faq-section`          — Base/Main's PDP (`sections/faq.liquid`)
       * Both expose product.metafields.faqs.* but with different wrapper markup;
       * the Section Rendering API call later returns whichever the PDP uses.
       */
      function extractProductFaqsSectionIdFromHtmlChunk(buffer) {
        if (!buffer) return null;
        var idx = buffer.indexOf('product-faqs-section');
        if (idx === -1) idx = buffer.indexOf('faq-section');
        if (idx === -1) return null;
        var head = buffer.slice(0, idx);
        var secRe = /id="shopify-section-(template--[^"]+)"/g;
        var last = null;
        var sm;
        while ((sm = secRe.exec(head)) !== null) {
          last = sm[1];
        }
        return last;
      }

      function resolveProductFaqsSectionId(productHandle) {
        if (!productHandle) return Promise.resolve(null);
        var cacheKey = faqsSectionIdCacheKey(productHandle);
        try {
          var cached = sessionStorage.getItem(cacheKey);
          if (cached === '__none__') return Promise.resolve(null);
          if (cached && /^template--/.test(cached)) return Promise.resolve(cached);
        } catch (e) {}

        var url = '/products/' + encodeURIComponent(productHandle);
        var MAX_BYTES = 2800000;

        return cqFetchWithRetries(
          url,
          {
            method: 'GET',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html,*/*' },
          },
          { maxAttempts: 3, baseBackoffMs: 400 }
        )
          .then(function (response) {
            if (!response.ok) return null;
            var reader = response.body && response.body.getReader();
            if (!reader) {
              return response.text().then(function (html) {
                return extractProductFaqsSectionIdFromHtmlChunk(html);
              });
            }

            var decoder = new TextDecoder();
            var buffer = '';

            function pump() {
              return reader.read().then(function (result) {
                if (result.done) {
                  return extractProductFaqsSectionIdFromHtmlChunk(buffer);
                }

                buffer += decoder.decode(result.value, { stream: true });

                var id = extractProductFaqsSectionIdFromHtmlChunk(buffer);
                if (id) {
                  reader.cancel().catch(function () {});
                  return id;
                }

                if (buffer.length >= MAX_BYTES) {
                  reader.cancel().catch(function () {});
                  return extractProductFaqsSectionIdFromHtmlChunk(buffer);
                }

                return pump();
              });
            }

            return pump();
          })
          .then(function (id) {
            try {
              if (id) sessionStorage.setItem(cacheKey, id);
              else sessionStorage.setItem(cacheKey, '__none__');
            } catch (e2) {}
            return id || null;
          })
          .catch(function () {
            try {
              sessionStorage.setItem(cacheKey, '__none__');
            } catch (e3) {}
            return null;
          });
      }

      function fetchFaqsSectionMarkup(productHandle, sectionId) {
        if (!productHandle || !sectionId) return Promise.resolve('');
        var params = new URLSearchParams({ section_id: sectionId });
        var url = '/products/' + encodeURIComponent(productHandle) + '?' + params.toString();

        return cqFetchWithRetries(
          url,
          { method: 'GET', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html,*/*' } },
          { maxAttempts: 3, baseBackoffMs: 400 }
        )
          .then(function (response) {
            if (!response.ok) return '';
            return response.text();
          })
          .then(function (raw) {
            var inner = unwrapShopifySectionHtml(raw);
            // Accept both: `faqs-section` (substring of `product-faqs-section`
            // from Main) and `faq-section` (Base/Main's faq.liquid).
            if (!inner) return '';
            if (inner.indexOf('faqs-section') === -1 && inner.indexOf('faq-section') === -1) {
              return '';
            }
            return inner;
          })
          .catch(function () {
            return '';
          });
      }

      function syncComplexionQuizFaqsForHeroProduct(productHandle) {
        if (!cqFaqsShopifySectionEl || !productHandle) return;
        var seq = ++cqFaqsSyncSeq;

        resolveProductFaqsSectionId(productHandle)
          .then(function (sectionId) {
            if (seq !== cqFaqsSyncSeq) return '';
            return fetchFaqsSectionMarkup(productHandle, sectionId);
          })
          .then(function (inner) {
            if (seq !== cqFaqsSyncSeq) return;
            var secEl = cqFaqsShopifySectionEl;
            // Item markers: `faq-item` (Main's product-faqs) or `faq__block`
            // (Base/Main's faq section). Either presence = valid FAQ payload.
            var hasItems =
              !!inner &&
              (inner.indexOf('faq-item') !== -1 || inner.indexOf('faq__block') !== -1);
            if (!hasItems) {
              secEl.innerHTML = '';
              secEl.style.display = 'none';
              return;
            }
            secEl.style.display = '';
            secEl.innerHTML = inner;
            // Inner wrapper: `.faqs-section` (Main) or `.faq-section` (Base/Main).
            var fs = secEl.querySelector('.faqs-section, .faq-section');
            if (fs) {
              fs.classList.add('hidden_by_default');
              fs.setAttribute('data-cq-dynamic-faqs', '1');
            }
          })
          .catch(function () {});
      }

      function escapeHtml(value) {
        if (value == null) return '';
        return String(value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      // Shade line: name in black, rest (incl. separator before description) in #757575 via CSS class.
      function formatShadeDescriptionHtml(name, description) {
        const n = String(name == null ? '' : name).trim();
        const d = String(description == null ? '' : description).trim();
        if (!n && !d) return '';
        if (!n) {
          return `<span class="complexion-quiz__match-shade-desc">${escapeHtml(d)}</span>`;
        }
        if (!d) {
          return `<span class="complexion-quiz__match-shade-name">${escapeHtml(n)}</span>`;
        }
        const sep = /^is\b/i.test(d) ? ' ' : ' - ';
        return (
          `<span class="complexion-quiz__match-shade-name">${escapeHtml(n)}</span>` +
          `<span class="complexion-quiz__match-shade-desc">${sep}${escapeHtml(d)}</span>`
        );
      }

      /** Quiz payload keys vary by app version; try common names for “coverage” answers. */
      function complexionQuizCoverageAnswer(quizData) {
        if (!quizData || typeof quizData !== 'object') return '';
        const q = quizData;
        const raw =
          q.coveragePreference ||
          q.coverage ||
          q.finish ||
          q.makeupCoverage ||
          q.desiredCoverage ||
          q.coverageLevel ||
          '';
        return String(raw || '').trim();
      }

      /**
       * Replaces CMS `whyThisWorks` with copy driven by quiz answers + hero context.
       * Single hero: best (only) product. Tabbed: “Your pick” uses URL product + shade; “Best match” uses #1 recommended + shade.
       */
      function buildComplexionQuizWhyThisWorksParagraph(quizData, opts) {
        if (!quizData || typeof quizData !== 'object') return '';
        opts = opts || {};
        const dualTabs = !!opts.dualTabs;
        const activeTab = opts.activeTab === 'best' ? 'best' : 'pick';
        const productTitle = String(opts.productTitle || '').trim();
        const shadeName = String(opts.shadeName || '').trim();
        const coverage = complexionQuizCoverageAnswer(quizData);
        const skinTone = String(quizData.skinTone || '').trim();
        const undertone = String(quizData.undertone || '').trim();
        const skinType = String(quizData.skinType || '').trim();

        const coverageLead = coverage ? 'Your ' + coverage + ' coverage preference' : 'Your coverage preference';

        if (dualTabs && activeTab === 'pick') {
          if (!productTitle || !shadeName) return '';
          return (
            'Based on your interest in ' +
            productTitle +
            ', ' +
            shadeName +
            ' is our top shade pick for you in this formula. It will complement your ' +
            skinTone +
            ' skin tone, ' +
            undertone +
            ' undertone, and keep your ' +
            skinType +
            ' skin hydrated and comfortable.'
          );
        }

        if (dualTabs && activeTab === 'best') {
          if (!productTitle || !shadeName) return '';
          const covPair = coverage ? 'your ' + coverage + ' coverage preference' : 'your coverage preference';
          return (
            'Based on your responses, we recommend ' +
            productTitle +
            ' in ' +
            shadeName +
            ' for you. It pairs perfectly with ' +
            covPair +
            ', and will complement your ' +
            skinTone +
            ' skin tone, ' +
            undertone +
            ' undertone, and keep your ' +
            skinType +
            ' skin hydrated and comfortable.'
          );
        }

        // Single-result hero (no dual tabs): top recommended product only
        if (!productTitle) return '';
        return (
          coverageLead +
          ' pairs perfectly with our ' +
          productTitle +
          ', It will also complement your ' +
          skinTone +
          ' skin tone, ' +
          undertone +
          ', and keep your ' +
          skinType +
          ' skin hydrated and comfortable.'
        );
      }

      function updatePDPUI(quizData, variantData, recommendedEntry, uiOptions) {
        const target = cqFindHeroDescriptionMount(productHeroTarget);

        if (!target) return;

        uiOptions = uiOptions || {};
        const dualTabsUi = !!uiOptions.dualTabs;
        const activeTab = uiOptions.activeTab === 'best' ? 'best' : 'pick';

        const vData = variantData || {};
        const recommended =
          recommendedEntry ||
          (quizData && quizData.recommendedProducts && quizData.recommendedProducts[0]) ||
          {};
        const productName = (vData.productTitle && String(vData.productTitle).trim()) || '';
        const shadeName = complexionQuizPrimaryShadeName(recommended);
        const whyThisWorks = buildComplexionQuizWhyThisWorksParagraph(quizData, {
          dualTabs: dualTabsUi,
          activeTab: activeTab,
          productTitle: productName,
          shadeName: shadeName,
        });
        const shadeDesc = vData.description || '';
        const swatchColor = vData.swatchColor || '';
        const swatchImage = vData.swatchImage || '';

        const skinTypeValue = quizData.skinType || '';
        const skinToneValue = quizData.skinTone || '';
        const undertoneValue = quizData.undertone || '';
        const concernsRaw = quizData.concerns;
        const concernsValue = Array.isArray(concernsRaw)
          ? concernsRaw
              .map(function (v) {
                var s = String(v || '').trim();
                if (/^none([_\s]of[_\s]these)?$/i.test(s)) return 'None';
                return s;
              })
              .filter(Boolean)
              .join(', ')
          : (concernsRaw || '');

        const fields = [
          { label: 'Skin Type', value: skinTypeValue },
          { label: 'Skin Tone', value: skinToneValue },
          { label: 'Undertone', value: undertoneValue },
          { label: 'Skin Concern', value: concernsValue },
        ];

        const checkIcon = `
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="black"/>
            <path d="M14.5 7L8.71025 12.834C8.49058 13.0553 8.13442 13.0553 7.91475 12.834L5.5 10.4008" stroke="black" stroke-linecap="round"/>
          </svg>
        `;

        const listItems = fields
          .map(function (field) {
            return `
            <li>
              <span class="complexion-quiz__answer-icon">${checkIcon}</span>
              <div class="complexion-quiz__answer-text">
                <span class="complexion-quiz__answer-label">${field.label}:</span> <span class="complexion-quiz__answer-value">${field.value || 'Not specified'}</span>
              </div>
            </li>
          `;
          })
          .join('');

        const shadeDescHtml = formatShadeDescriptionHtml(shadeName, shadeDesc);
        let swatchStyle = '';
        if (swatchImage) {
          swatchStyle = `background-image:url(${escapeHtml(swatchImage)});background-size:cover;background-position:center`;
        } else if (swatchColor) {
          swatchStyle = `background-color:${escapeHtml(swatchColor)}`;
        }
        if (!swatchStyle && shadeName) {
          const themeColor = cqNormalizeHexColor(cqLookupThemeSwatchColor(shadeName));
          if (themeColor) {
            swatchStyle = `background-color:${escapeHtml(themeColor)}`;
          }
        }
        if (!swatchStyle && productHeroTarget) {
          swatchStyle = cqSwatchStyleFromHeroDom(productHeroTarget, shadeName);
        }
        const swatchBlock = swatchStyle
          ? `<span class="complexion-quiz__match-swatch-outer" aria-hidden="true"><span class="complexion-quiz__match-swatch-inner" style="${swatchStyle}"></span></span>`
          : '';
        const matchTabbedClass = dualTabsUi ? ' complexion-quiz__match--tabbed' : '';
        const matchHtml =
          productName || shadeDescHtml || swatchBlock
            ? `
          <div class="complexion-quiz__match${matchTabbedClass}">
            <h2 class="complexion-quiz__match-title">Your Match</h2>
            <div class="complexion-quiz__match-card">
              <div class="complexion-quiz__match-head">
                ${swatchBlock}
                ${productName ? `<div class="complexion-quiz__match-product">${escapeHtml(productName).toUpperCase()}</div>` : ''}
              </div>
              ${shadeDescHtml ? `<div class="complexion-quiz__match-shade-line">${shadeDescHtml}</div>` : ''}
            </div>
          </div>
        `
            : '';

        const whyHtml = whyThisWorks
          ? `
          <div class="complexion-quiz__why">
            <h2 class="complexion-quiz__why-title">Why this works</h2>
            <p class="complexion-quiz__why-text">${escapeHtml(whyThisWorks)}</p>
          </div>
        `
          : '';

        const tabsHtml = dualTabsUi
          ? `
          <div class="complexion-quiz__hero-tabs" role="tablist" aria-label="Your match">
            <button type="button" role="tab" class="complexion-quiz__hero-tab ${activeTab === 'pick' ? 'is-active' : ''}" aria-selected="${activeTab === 'pick' ? 'true' : 'false'}" data-cq-tab="pick">Your pick</button>
            <button type="button" role="tab" class="complexion-quiz__hero-tab ${activeTab === 'best' ? 'is-active' : ''}" aria-selected="${activeTab === 'best' ? 'true' : 'false'}" data-cq-tab="best">Best match</button>
          </div>
        `
          : '';

        const html = `
          <div class="complexion-quiz__answers">
            <h1 class="complexion-quiz__answers-title">About your match</h1>
            <p class="complexion-quiz__answers-sub">Selected just for you based on your quiz answers:</p>
            <ul class="complexion-quiz__answers-list">
              ${listItems}
            </ul>
          </div>
          ${tabsHtml}
          ${matchHtml}
          ${whyHtml}
        `;

        let mount = target.querySelector('[data-cq-inline-results]');
        if (!mount) {
          mount = document.createElement('div');
          mount.setAttribute('data-cq-inline-results', '');
          target.insertAdjacentElement('afterbegin', mount);
        }
        mount.innerHTML = html;
      }

      function findVariantByName(productJson, name) {
        if (!productJson || !Array.isArray(productJson.variants) || !name) return null;
        const target = normalizeShade(name);
        if (!target) return null;

        let match = productJson.variants.find((v) => normalizeShade(v.title) === target);

        if (!match) {
          match = productJson.variants.find((v) =>
            [v.option1, v.option2, v.option3].some((o) => normalizeShade(o) === target),
          );
        }

        if (!match) {
          match = productJson.variants.find((v) => normalizeShade(v.title).includes(target));
        }

        return match || null;
      }

      function findVariantIdByShadeName(productJson, name) {
        const variant = findVariantByName(productJson, name);
        return variant ? variant.id : null;
      }

      // json-data emits a string `swatch_color` (hex) from Liquid; if an object slips through older caches, coerce safely.
      function normalizeSwatchColorFromJson(raw) {
        if (raw == null || raw === '') return '';
        if (typeof raw === 'string') return raw.trim();
        if (typeof raw === 'object') {
          if (raw.value != null && raw.value !== '') return String(raw.value).trim();
          const hex = raw.hex;
          if (hex != null && hex !== '') return String(hex).trim();
        }
        return '';
      }

      // Fetches the `?view=json-data` template (which exposes variant description, hex `swatch_color`
      // from variant.metafields.swatch.color.value, and `swatch_image`) for the matched variant id.
      // Matches the lookup approach used by `product-quiz-essentials.liquid`.
      function fetchVariantData(productHandle, variantId) {
        const empty = { description: '', swatchColor: '', swatchImage: '' };
        if (!productHandle || !variantId) return Promise.resolve(empty);

        function buildVariantDataFromJsonVariant(variant) {
          if (!variant) return empty;
          var swatchColor = cqNormalizeHexColor(normalizeSwatchColorFromJson(variant.swatch_color));
          var swatchImage = variant.swatch_image ? String(variant.swatch_image).trim() : '';
          if (!swatchColor && !swatchImage && variant.title) {
            swatchColor = cqNormalizeHexColor(cqLookupThemeSwatchColor(variant.title));
          }
          return {
            description: variant.description ? String(variant.description).trim() : '',
            swatchColor: swatchColor,
            swatchImage: swatchImage,
          };
        }

        return cqFetchWithRetries(
          `/products/${encodeURIComponent(productHandle)}?view=json-data`,
          { method: 'GET', headers: { Accept: 'text/html,*/*' } },
          { maxAttempts: 3, baseBackoffMs: 400 }
        )
          .then((res) => (res.ok ? res.text() : null))
          .then((text) => {
            if (!text) return empty;
            try {
              const data = JSON.parse(text);
              if (!Array.isArray(data.variants)) return empty;
              const target = String(variantId);
              const variant = data.variants.find((v) => v && v.id != null && String(v.id) === target);
              return buildVariantDataFromJsonVariant(variant);
            } catch (e) {
              return empty;
            }
          })
          .catch(function () {
            return empty;
          });
      }

      /**
       * Promote deferred Videowise embeds after innerHTML injection.
       *
       * On a normal PDP, `connectedCallback()` of `<product-hero-new>` sets up an
       * IntersectionObserver on every `[data-phn-videowise-defer]` element that
       * lazily injects the embed HTML from its sibling `<script type="text/template"
       * data-phn-videowise-html>` tag.  After the quiz replaces the hero via
       * `productHeroTarget.innerHTML = html`, those observers are dead — the NEW
       * defer elements have no observer.  This function does the same job eagerly:
       * find every un-promoted defer node and inject the template HTML so Videowise
       * has a mount target when `syncVideowiseForQuizProduct` triggers it.
       */
      function cqPromoteDeferredVideowise(heroEl) {
        if (!heroEl) return;
        heroEl.querySelectorAll('[data-phn-videowise-defer]').forEach(function (embed) {
          if (embed.dataset.phnVideowiseLoaded) return;
          var tpl = embed.parentElement && embed.parentElement.querySelector('[data-phn-videowise-html]');
          if (!tpl) return;
          embed.dataset.phnVideowiseLoaded = 'true';
          embed.innerHTML = tpl.innerHTML;
        });
      }

      // Section Rendering uses the product template (same as normal PDP): Videowise may render outside
      // the accordion when enable_quiz_recommendations is false. Move it into “See it in action” here.
      function hasVisibleVideowiseContent(heroEl) {
        if (!heroEl) return false;
        const seeItPanel = heroEl.querySelector('div[data-heading="see-it-in-action"]');
        const scope = seeItPanel || heroEl;
        if (
          scope.querySelector(
            'iframe, video, [data-videowise-id], .vw-cmp__video-card, .vw-cmp__item',
          )
        ) {
          return true;
        }
        const widgets = scope.querySelectorAll('.reeview-app-widget');
        return Array.from(widgets).some(function (el) {
          if (!el) return false;
          if (el.children && el.children.length > 0) return true;
          if (el.shadowRoot && el.shadowRoot.children && el.shadowRoot.children.length > 0) return true;
          if (String(el.innerHTML || '').trim() !== '') return true;
          const rect = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
          return !!(rect && rect.height > 0);
        });
      }

      function applySeeItInActionVisibility(heroEl, forceVisible) {
        if (!heroEl) return;
        const accordions = heroEl.querySelector('.product__description-accordions');
        if (!accordions) return;
        const visible =
          typeof forceVisible === 'boolean' ? forceVisible : hasVisibleVideowiseContent(heroEl);
        accordions.classList.toggle('cq-see-it-in-action-ready', visible);
        const productDescriptionBtn = accordions.querySelector(
          'button[data-heading="product-description"]',
        );
        if (productDescriptionBtn) {
          productDescriptionBtn.style.borderTop = visible ? '' : '0';
        }
      }

      function scheduleSeeItInActionStabilizer(heroEl) {
        if (!heroEl) return;
        if (heroEl.__cqSeeItObserver) {
          try {
            heroEl.__cqSeeItObserver.disconnect();
          } catch (e) {}
          heroEl.__cqSeeItObserver = null;
        }
        if (heroEl.__cqSeeItTimer) {
          window.clearTimeout(heroEl.__cqSeeItTimer);
          heroEl.__cqSeeItTimer = null;
        }

        const seeItNodes = heroEl.querySelectorAll('[data-heading="see-it-in-action"]');
        if (!seeItNodes.length) return;
        // Start hidden (no layout flicker). Reveal only when content is truly rendered.
        applySeeItInActionVisibility(heroEl, false);

        const observer = new MutationObserver(function () {
          if (!heroEl || !heroEl.isConnected) return;
          if (hasVisibleVideowiseContent(heroEl)) {
            applySeeItInActionVisibility(heroEl, true);
            if (heroEl.__cqSeeItObserver) {
              try {
                heroEl.__cqSeeItObserver.disconnect();
              } catch (e) {}
              heroEl.__cqSeeItObserver = null;
            }
            if (heroEl.__cqSeeItTimer) {
              window.clearTimeout(heroEl.__cqSeeItTimer);
              heroEl.__cqSeeItTimer = null;
            }
          }
        });
        observer.observe(heroEl, { childList: true, subtree: true, attributes: true });
        heroEl.__cqSeeItObserver = observer;

        heroEl.__cqSeeItTimer = window.setTimeout(function () {
          if (!heroEl || !heroEl.isConnected) return;
          if (hasVisibleVideowiseContent(heroEl)) {
            applySeeItInActionVisibility(heroEl, true);
          } else {
            applySeeItInActionVisibility(heroEl, false);
          }
          if (heroEl.__cqSeeItObserver) {
            try {
              heroEl.__cqSeeItObserver.disconnect();
            } catch (e) {}
            heroEl.__cqSeeItObserver = null;
          }
          heroEl.__cqSeeItTimer = null;
        }, 1600);
      }

      function ensureVideowiseInsideAccordion(heroEl) {
        const accordions = heroEl.querySelector('.product__description-accordions');
        if (!accordions) return;

        const existingBtn = accordions.querySelector('button[data-heading="see-it-in-action"]');
        const existingPanel = accordions.querySelector('div[data-heading="see-it-in-action"]');
        if (existingBtn && existingPanel) {
          accordions.insertBefore(existingPanel, accordions.firstChild);
          accordions.insertBefore(existingBtn, existingPanel);
          existingBtn.setAttribute('aria-expanded', 'true');
          existingPanel.setAttribute('aria-hidden', 'false');
          existingPanel.setAttribute('style', 'height: auto');
          scheduleSeeItInActionStabilizer(heroEl);
          return;
        }

        // NOTE: exclude nodes already inside a `.utility__tabpanel` (Main's own
        // accordion) AND inside a `.phn-accordion` (Base/Main's accordion, built
        // by the branch below). Without the `.phn-accordion` guard this Main path
        // would re-grab content we already placed and double-wrap it.
        const externalVw = Array.from(heroEl.querySelectorAll('.product__description-videowise')).find(
          (el) => !el.closest('.utility__tabpanel') && !el.closest('.phn-accordion'),
        );
        if (externalVw) {
          // Main-style markup: build a utility__tab accordion around the
          // legacy .product__description-videowise element.
          const tabId = 'tabpanel-cq-videowise';
          const button = document.createElement('button');
          button.setAttribute('data-heading', 'see-it-in-action');
          button.setAttribute('aria-expanded', 'true');
          button.setAttribute('aria-controls', tabId);
          button.setAttribute('data-controls', tabId);
          button.className = 'utility__tab utility__tab--product';
          button.textContent = 'See it in action';

          const panel = document.createElement('div');
          panel.setAttribute('data-heading', 'see-it-in-action');
          panel.setAttribute('aria-hidden', 'false');
          panel.id = tabId;
          panel.className = 'utility__tabpanel utility__tabpanel--product';
          panel.setAttribute('style', 'height: auto');

          const inner = document.createElement('div');
          inner.className = 'text-underline';
          inner.appendChild(externalVw);

          panel.appendChild(inner);
          accordions.insertBefore(panel, accordions.firstChild);
          accordions.insertBefore(button, panel);
          scheduleSeeItInActionStabilizer(heroEl);
          return;
        }

        // Base/Main markup: the injected PDP renders `.phn-ugc` (containing the
        // VideoWise embed) OUTSIDE the accordion stack because the static PDP has
        // `enable_quiz_recommendations == false`. On the quiz results page we
        // relocate it INTO a "See it in action" accordion matching the sibling
        // `.phn-accordion` items.
        //
        // ROBUSTNESS: we move the ENTIRE `.phn-ugc` node (we never extract the
        // embed or leave an empty wrapper). VideoWise renders async into nodes
        // inside `.phn-ugc`; moving the whole subtree keeps its mount target
        // intact regardless of whether VideoWise rendered before or after this
        // runs — avoiding the "empty accordion + content still outside" race.
        //
        // We deliberately do NOT add `data-heading="see-it-in-action"` here:
        // that marker triggers Main's CSS gate which forces `display:block` and
        // would break `.phn-accordion__header`'s flexbox (no icon, no border).
        // The accordion is NOT display-gated either (see stylesheet note) — the
        // closed-shadow VideoWise widget can't be detected while hidden, so any
        // gate would deadlock and the section would never appear.
        var externalPhnUgc = Array.from(heroEl.querySelectorAll('.phn-ugc')).find(
          function (el) { return !el.closest('.phn-accordion'); }
        );

        // Idempotent / re-entrant: if the accordion already exists, just make
        // sure any stray (re-rendered) `.phn-ugc` is pulled back inside it.
        var existingVwAccordion = accordions.querySelector('.phn-accordion--videowise-quiz');
        if (existingVwAccordion) {
          if (externalPhnUgc) {
            var existingContent = existingVwAccordion.querySelector('.phn-accordion__content');
            if (existingContent) existingContent.appendChild(externalPhnUgc);
          }
          scheduleSeeItInActionStabilizer(heroEl);
          return;
        }

        if (!externalPhnUgc) return;

        var phnBodyId = 'phn-cq-videowise-body';
        var phnAccordion = document.createElement('div');
        phnAccordion.className = 'phn-accordion phn-accordion--videowise-quiz';

        var phnButton = document.createElement('button');
        phnButton.type = 'button';
        phnButton.className = 'phn-accordion__header';
        // Wires into Base/Main's existing accordion toggle handler.
        phnButton.setAttribute('data-phn-accordion-toggle', '');
        phnButton.setAttribute('aria-expanded', 'true');
        phnButton.setAttribute('aria-controls', phnBodyId);
        phnButton.innerHTML =
          '<span>See it in action</span>' +
          '<span class="phn-accordion__icon" aria-hidden="true">−</span>';

        var phnBody = document.createElement('div');
        phnBody.className = 'phn-accordion__body';
        phnBody.id = phnBodyId;

        var phnContent = document.createElement('div');
        // IMPORTANT: do NOT add `product__description-videowise` here. That class
        // is what the Main `externalVw` path above scans for — adding it makes a
        // re-run hijack this content and re-wrap it in a `utility__tabpanel`,
        // emptying our accordion. VideoWise (re)trigger keys off the embed's
        // `.reeview-app-widget` element instead, which moves in with `.phn-ugc`.
        phnContent.className = 'phn-accordion__content';

        // Move the ENTIRE `.phn-ugc` node intact into the accordion content.
        phnContent.appendChild(externalPhnUgc);

        phnBody.appendChild(phnContent);
        phnAccordion.appendChild(phnButton);
        phnAccordion.appendChild(phnBody);

        accordions.insertBefore(phnAccordion, accordions.firstChild);
        scheduleSeeItInActionStabilizer(heroEl);
      }

      // Collapse other description accordions on quiz results; keep “See it in action” open for Videowise.
      function collapseQuizProductAccordions(heroEl) {
        const root = heroEl.querySelector('.product__description-accordions.js-accordion');
        if (!root) return;
        root.querySelectorAll('button[data-controls]').forEach((btn) => {
          if (btn.getAttribute('data-heading') === 'see-it-in-action') return;
          const panelId = btn.getAttribute('data-controls');
          if (!panelId) return;
          const panel = document.getElementById(panelId);
          if (!panel || !root.contains(panel)) return;
          btn.setAttribute('aria-expanded', 'false');
          panel.setAttribute('aria-hidden', 'true');
          panel.setAttribute('style', 'height: 0px');
        });
      }

      // Videowise/Reeview placeholders are injected after initial page load; the app does not rescan by default.
      // Mirror `assets/custom-videowise.js` (pid + bulk trigger). Retries use microtasks + animation frames (no fixed ms delays).
      // The phn hero (product-hero-new) defers its Videowise embed: the markup
      // ships an empty [data-phn-videowise-defer] div plus the embed HTML in a
      // sibling <script type="text/template" data-phn-videowise-html>, injected
      // only when the hero's own IntersectionObserver fires. On quiz results the
      // pid sync + bulk trigger below run immediately after hero injection —
      // before that observer ever fires — so the `.reeview-app-widget`
      // placeholder wouldn't exist yet and the sync would bail (and Videowise
      // never rescans on its own). Force-inject any pending deferred embeds now.
      // Setting `phnVideowiseLoaded` keeps the hero's observer from re-injecting.
      function cqForceInjectDeferredVideowise(root) {
        if (!root || typeof root.querySelectorAll !== 'function') return;
        root.querySelectorAll('[data-phn-videowise-defer]').forEach(function (embed) {
          if (embed.dataset.phnVideowiseLoaded) return;
          var tpl = embed.parentElement
            ? embed.parentElement.querySelector('[data-phn-videowise-html]')
            : null;
          if (!tpl) return;
          embed.dataset.phnVideowiseLoaded = 'true';
          embed.innerHTML = tpl.innerHTML;
        });
      }

      function syncVideowiseForQuizProduct(productId, heroRoot, syncOptions) {
        syncOptions = syncOptions || {};
        const quick = !!syncOptions.quick;
        const root = heroRoot || productHeroTarget;

        if (productId == null || productId === '') {
          return;
        }
        const pidNum = typeof productId === 'number' ? productId : parseInt(String(productId), 10);
        if (!Number.isFinite(pidNum)) {
          return;
        }

        cqForceInjectDeferredVideowise(root);

        if (
          !root ||
          (!root.querySelector('.product__description-videowise') &&
            !root.querySelector('.reeview-app-widget'))
        ) {
          return;
        }

        window.videowiseInfo = window.videowiseInfo || {};
        window.videowiseInfo.pid = pidNum;

        if (window.__st && typeof window.__st === 'object') {
          window.__st.rid = pidNum;
          window.__st.pageurl = window.location.href;
        }

        function trigger() {
          try {
            window.videowiseIdsLoaded = [];
          } catch (e) {}
          try {
            if (typeof window.initVideowise === 'function') {
              window.initVideowise();
            }
          } catch (e) {}
          try {
            if (typeof window.videowiseBulkTrigger === 'function') {
              window.videowiseBulkTrigger();
            }
          } catch (e) {}
        }

        trigger();

        if (quick) {
          queueMicrotask(trigger);
          return;
        }

        queueMicrotask(trigger);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            trigger();
            queueMicrotask(trigger);
          });
        });
      }

      function cqApplyQuizVariantToInjectedHero(heroRoot, variantId, shadeName) {
        if (!heroRoot) return;
        function selectMatchedSwatch() {
          var scope = heroRoot.querySelector('product-hero-new') || heroRoot;
          var btn = null;
          if (variantId != null && variantId !== '') {
            btn = scope.querySelector('[data-phn-std-shade][data-variant-id="' + variantId + '"]');
          }
          if (!btn && shadeName) {
            var want = String(shadeName).trim().toLowerCase();
            scope.querySelectorAll('[data-phn-std-shade]').forEach(function (b) {
              if ((b.getAttribute('data-variant-title') || '').trim().toLowerCase() === want) btn = b;
            });
          }
          if (btn) {
            btn.click();
            return;
          }
          // No swatch button for the recommended shade because it is hidden from the online
          // store and filtered out of the hero picker. The quiz already resolved its variant id
          // from /products/{handle}.js, so write it straight into the form's id input (name="id")
          // so Add to Cart adds the recommended shade instead of the auto-selected default.
          if (variantId != null && variantId !== '') {
            var form = scope.querySelector('[data-phn-form-std]') || scope;
            var idInput = form.querySelector('[data-phn-std-variant-id]');
            if (idInput) idInput.value = String(variantId);
            var installmentInput = form.querySelector('[data-phn-std-installment-variant]');
            if (installmentInput) installmentInput.value = String(variantId);
          }
        }
        selectMatchedSwatch();
        requestAnimationFrame(function () {
          requestAnimationFrame(selectMatchedSwatch);
        });
      }

      function injectHero(html, variantData, productId, injectCtx) {
        injectCtx = injectCtx || {};
        const quizDataForUi = injectCtx.quizData != null ? injectCtx.quizData : data;
        const recommendedEntry = injectCtx.recommendedEntry;
        const dualTabsUi = injectCtx.dualTabs != null ? injectCtx.dualTabs : tabState.dualTabs;
        const activeTabUi =
          injectCtx.activeTab != null ? injectCtx.activeTab : tabState.activeTab || 'best';
        const videowiseMode = injectCtx.videowiseMode || 'full';

        productHeroTarget.innerHTML = html;
        cqPromoteDeferredVideowise(productHeroTarget);
        cqResolveIgGalleryForInjectedHero(productHeroTarget, injectCtx.variantId);
        ensureVideowiseInsideAccordion(productHeroTarget);
        collapseQuizProductAccordions(productHeroTarget);
        updatePDPUI(quizDataForUi, variantData || {}, recommendedEntry, {
          dualTabs: dualTabsUi,
          activeTab: activeTabUi,
        });
        bindComplexionQuizHeroTabsIfNeeded(productHeroTarget);
        if (productId != null && productId !== '') {
          productHeroTarget.setAttribute('data-cq-hero-product-id', String(productId));
        } else {
          productHeroTarget.removeAttribute('data-cq-hero-product-id');
        }
        if (window.theme && typeof window.theme.reinitViewAfterInject === 'function') {
          window.theme.reinitViewAfterInject(productHeroTarget);
        }
        cqApplyQuizVariantToInjectedHero(
          productHeroTarget,
          injectCtx.variantId,
          complexionQuizPrimaryShadeName(
            recommendedEntry ? complexionQuizEntryWithMergedShades(recommendedEntry) : recommendedEntry,
          ),
        );

        /* After a tab swap the description column height changes; nudge the sticky engine. */
        (function refreshCqStickyBounds() {
          function nudge() {
            /* Quiz header height → sticky ATC translateY; +30 px gap for sticky gallery top. */
            var qh = document.querySelector('.quiz-header');
            var h = qh ? qh.offsetHeight : 0;
            document.documentElement.style.setProperty('--cq-quiz-header-height', h + 'px');
            document.documentElement.style.setProperty('--cq-sticky-media-top', (h + 30) + 'px');
          }
          requestAnimationFrame(function () {
            nudge();
            requestAnimationFrame(nudge);
          });

          /* ResizeObserver: whenever the videowise accordion expands/collapses the description,
             the flex-row re-flows and sticky re-evaluates automatically (CSS handles it).
             We also re-check the top var here as a safety measure. */
          if (typeof ResizeObserver !== 'undefined') {
            if (window.__cqDescRO) { window.__cqDescRO.disconnect(); }
            var descEl = productHeroTarget.querySelector('#product-description')
                      || productHeroTarget.querySelector('.product__description');
            if (descEl) {
              window.__cqDescRO = new ResizeObserver(nudge);
              window.__cqDescRO.observe(descEl);
            }
          }
        })();

        if (cqComplexionResultsUiRevealed) {
          finalizeComplexionQuizResultsShell();
        } else {
          /* Arm before flagging the pending reveal: if the loader already
           * finished, the tryReveal call right below would otherwise reveal
           * instantly, before the gate can hold it for Videowise. */
          cqArmVideowiseRevealGate(productHeroTarget);
          cqHeroInjectPendingReveal = true;
          tryRevealComplexionQuizResultsUiAfterLoader();
          if (typeof queueMicrotask === 'function') {
            queueMicrotask(function () {
              tryRevealComplexionQuizResultsUiAfterLoader();
            });
          } else {
            setTimeout(function () {
              tryRevealComplexionQuizResultsUiAfterLoader();
            }, 0);
          }
        }

        syncVideowiseForQuizProduct(productId, productHeroTarget, {
          quick: videowiseMode === 'quick',
        });
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            ensureVideowiseInsideAccordion(productHeroTarget);
            scheduleSeeItInActionStabilizer(productHeroTarget);
          });
        });

        var heroFaqHandle = recommendedEntry && recommendedEntry.handle;
        if (heroFaqHandle) {
          syncComplexionQuizFaqsForHeroProduct(heroFaqHandle);
        }
      }

      function fetchHeroBundleForEntry(entry) {
        entry = complexionQuizEntryWithMergedShades(entry);
        const productHandle = entry && entry.handle;
        if (!productHandle) return Promise.resolve(null);

        const shadeForVariant = complexionQuizPrimaryShadeName(entry);

        return cqFetchWithRetries(
          `/products/${encodeURIComponent(productHandle)}.js`,
          {
            headers: { Accept: 'application/json' },
          },
          { maxAttempts: 3, baseBackoffMs: 400 }
        )
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .then(function (productJson) {
            if (!productJson) return null;

            const productTitle =
              productJson && productJson.title ? String(productJson.title).trim() : '';
            const productId = productJson && productJson.id != null ? productJson.id : null;
            const variantId =
              shadeForVariant && productJson ? findVariantIdByShadeName(productJson, shadeForVariant) : null;

            const heroPromise = fetchProductHeroMarkup(productHandle, variantId);

            const variantDataPromise = fetchVariantData(productHandle, variantId).then(function (vd) {
              return Object.assign({}, vd, { productTitle: productTitle });
            });

            return Promise.all([heroPromise, variantDataPromise]).then(function (results) {
              return {
                html: results[0],
                variantData: results[1],
                productId: productId,
                variantId: variantId,
              };
            });
          })
          .catch(function () {
            return null;
          });
      }

      function fetchPDPHeroForEntry(entry, fetchOptions) {
        fetchOptions = fetchOptions || {};
        const videowiseMode = fetchOptions.videowiseMode || 'full';
        const uiActiveTab =
          fetchOptions.uiActiveTab != null ? fetchOptions.uiActiveTab : tabState.activeTab;

        const seq = ++heroLoadSeq;

        function loadBundleWithRetries(bAttempt) {
          return fetchHeroBundleForEntry(entry).then(function (bundle) {
            if (bundle || bAttempt >= 2) {
              return bundle;
            }
            return cqDelay(500 + bAttempt * 500).then(function () {
              return loadBundleWithRetries(bAttempt + 1);
            });
          });
        }

        loadBundleWithRetries(0)
          .then(function (bundle) {
            if (!bundle) {
              return;
            }
            if (seq !== heroLoadSeq) {
              return;
            }
            injectHero(bundle.html, bundle.variantData, bundle.productId, {
              quizData: data,
              recommendedEntry: entry,
              dualTabs: tabState.dualTabs,
              activeTab: uiActiveTab,
              videowiseMode: videowiseMode,
              variantId: bundle.variantId,
            });
          })
          .catch(function () {});
      }

      function cqArmRevealSafetyTimers(runId, bestEntryRef) {
        clearTimeout(cqRevealSafetyTimerFast);
        clearTimeout(cqRevealSafetyTimerSlow);
        cqRevealSafetyTimerFast = setTimeout(function () {
          if (runId !== cqResultsRunId || cqComplexionResultsUiRevealed) return;
          if (cqHeroInjectPendingReveal && !cqLoaderFinishedForResults) {
            cqLoaderFinishedForResults = true;
            tryRevealComplexionQuizResultsUiAfterLoader();
          }
        }, 2800);
        cqRevealSafetyTimerSlow = setTimeout(function () {
          if (runId !== cqResultsRunId || cqComplexionResultsUiRevealed) return;
          cqLoaderFinishedForResults = true;
          tryRevealComplexionQuizResultsUiAfterLoader();
          if (cqComplexionResultsUiRevealed) return;
          /* Hero fetch can fail on template drift — never leave the app loader visible indefinitely. */
          cqHeroInjectPendingReveal = false;
          cqComplexionResultsUiRevealed = true;
          finalizeComplexionQuizResultsShell();
          if (bestEntryRef && bestEntryRef.handle) {
            fetchPDPHeroForEntry(bestEntryRef, {
              videowiseMode: 'full',
              uiActiveTab: 'best',
            });
          }
        }, 14000);
      }

      if (dualTabs && pickEntry && bestEntry) {
        Promise.all([fetchHeroBundleForEntry(pickEntry), fetchHeroBundleForEntry(bestEntry)])
          .then(function (bundles) {
            const pickB = bundles[0];
            const bestB = bundles[1];
            if (!pickB || !bestB) {
              dualHeroBundles = null;
              fetchPDPHeroForEntry(pickEntry, {
                videowiseMode: 'full',
                uiActiveTab: 'pick',
              });
              return;
            }
            dualHeroBundles = { pick: pickB, best: bestB };
            injectHero(pickB.html, pickB.variantData, pickB.productId, {
              quizData: data,
              recommendedEntry: pickEntry,
              dualTabs: true,
              activeTab: 'pick',
              videowiseMode: 'full',
              variantId: pickB.variantId,
            });
          })
          .catch(function () {
            dualHeroBundles = null;
            fetchPDPHeroForEntry(pickEntry, {
              videowiseMode: 'full',
              uiActiveTab: 'pick',
            });
          });
      } else {
        fetchPDPHeroForEntry(bestEntry, {
          videowiseMode: 'full',
          uiActiveTab: 'best',
        });
      }

      cqArmRevealSafetyTimers(cqThisResultsRunId, bestEntry);
      if (typeof queueMicrotask === 'function') {
        queueMicrotask(function () {
          tryRevealComplexionQuizResultsUiAfterLoader();
        });
      } else {
        setTimeout(function () {
          tryRevealComplexionQuizResultsUiAfterLoader();
        }, 0);
      }
    }

    document.addEventListener('complexion-quiz:results-ready', onComplexionQuizResultsReady, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
